module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "top-panel bg-deveo-gradient"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n                CORE\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "300px"
    }
  })])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "102%",
      "height": "60px",
      "margin-top": "-86px",
      "z-index": "99"
    },
    attrs: {
      "src": "http://iqonicthemes.com/themes/sofbox/v1/images/banner/02.png"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "min-height": "400px",
      "position": "relative"
    }
  }, [_c('img', {
    staticClass: "hello",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": "/static/images/core.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "50%",
      "position": "absolute",
      "right": "0",
      "top": "-400px"
    },
    attrs: {
      "src": "http://iqonicthemes.com/themes/sofbox/v1/images/banner/01.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-078ddb6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/core/pages/index.vue
// module id = 299
// module chunks = 1